import React, { PropTypes } from 'react'

import './LabeledIconInput.scss'
import LabeledIcon from '../LabeledIcon'

const LabeledIconInput = (props) => {
  const {
    id,
    label,
    input,
    iconType,
    iconContent,
    type,
    disabled
  } = props
  return (
    <div className='LabeledIconInput'>
      <input type={type} id={id} disabled={disabled} {...input} />
      <label htmlFor={id}>
        <LabeledIcon label={label} iconType={iconType} iconContent={iconContent} />
      </label>
    </div>
  )
}
LabeledIconInput.displayName = 'LabeledIconInput'
LabeledIconInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  input: PropTypes.object,
  iconType: PropTypes.oneOf(['icon', 'text']).isRequired,
  iconContent: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
  disabled: PropTypes.bool
}
LabeledIcon.defaultProps = {
  iconType: 'icon',
  iconContent: 'logo',
  disabled: false
}

export default LabeledIconInput



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/LabeledIconInput/LabeledIconInput.js